import { parseZone } from "moment";
const currentDate = parseZone(new Date()).format("YYYY-MM-DD");

export const newRowIndex = 9999;

export const addNewContractsRow = {
  id: newRowIndex,
  company_name: "",
  created_date: currentDate,
  country: "",
  unp: "",
  contract: "",
  note: "",
  status: "",
  ban_on_registration: "",
  documents: "",
  temporary: true,
};
